import {FC, useEffect, useState} from 'react';
import {IonCheckbox} from '@ionic/react';
import actions from '../../api/colors';
import UIImage from '../UICommon/UIImage';
import UIHeart from './UIHeart';
import defaultImg from '../../assets/images/colorPlaceholder.png';

type UIColorCardProps = {
  id?: number;
  name: string;
  batchno?: {
    name: string;
    updated_at: string;
  };
  tone?: string;
  brand: string;
  img?: string;
  refetchFavorites: Function;
  setIsLoadingFavorites: Function;
  isFavorite?: boolean;
  setChosenColors: Function;
  chosenColors: any;
  style?: string;
}

const UIColorCard: FC<UIColorCardProps> = ({
  name,
  batchno,
  img,
  id,
  tone,
  brand,
  refetchFavorites,
  setIsLoadingFavorites,
  isFavorite,
  setChosenColors,
  chosenColors,
  style,
}) => {
  const [favoritesHeart, setFavoritesHeart] = useState(false);
  const [checked, setChecked] = useState(false);

  const addColorToList = (id: number) => {
    setChecked(!checked);
    const tmpChosenColors = [...chosenColors];
    if (tmpChosenColors.filter((el) => el.id === id).length > 0) {
      for (let i = 0; i < tmpChosenColors.length; i++) {
        if (tmpChosenColors[i].id === id) {
          tmpChosenColors.splice(i, 1);
          setChosenColors(tmpChosenColors);
        }
      }
    } else {
      tmpChosenColors.push({
        id: id,
        name: name,
        brand: brand,
        batchno: batchno ? batchno.name : '',
        created: batchno ? batchno.updated_at : '',
      });
      setChosenColors(tmpChosenColors);
    }
  };

  const isChecked = (chosenColors: any[]) => {
    if (chosenColors.filter((el: any) => el.id == id).length > 0) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    setChecked(isChecked(chosenColors));
  }, [chosenColors]);

  const saveFavorite = (id: number) => {
    setFavoritesHeart(!favoritesHeart);
    setIsLoadingFavorites(true);
    actions.updateFavoriteColors(id).then(() => {
      refetchFavorites();
      setIsLoadingFavorites(false);
    });
  };

  return (
    <div
      className={`border border-gray-colorsBorder rounded-5 w-36 h-48 relative ${style}`}
      onClick={(e) => addColorToList(id!)}>
      <div className='absolute top-2 left-0 px-2 flex justify-between items-center w-full'>
        <UIHeart favoritesHeart={favoritesHeart} saveFavorite={saveFavorite} id={id} isFavorite={isFavorite}/>
        <IonCheckbox
          mode='ios'
          slot="end"
          className='color-checkbox'
          checked={checked}></IonCheckbox>
      </div>
      <div className='h-3/4'>
        <UIImage
          url={img || defaultImg}
          rollBackImage={defaultImg}
          style='rounded-t-5 object-scale-down'
        />
      </div>
      <div className='h-1/4 text-center flex flex-col justify-evenly border-t border-gray-colorsBorder'>
        <div className='uppercase font-semibold text-11 overflow-hidden'>{name}</div>
        <div className='text-9 flex flex-col'>
          <span>Märke: {brand}</span>
          {tone && <span>Ton: {tone}</span>}
        </div>
      </div>
    </div>
  );
};

export default UIColorCard;
